import posthog from "posthog-js"

import { runtimeConfig } from "./runtimeConfig"

// Initialize PostHog
if (
  typeof window !== "undefined" &&
  (runtimeConfig.VITE_API_URL === "https://app-staging-api.costory.io" ||
    runtimeConfig.VITE_ENVIRONMENT === "production") &&
  runtimeConfig.VITE_POSTHOG_API_KEY // Only initialize if API key is present
) {
  posthog.init(runtimeConfig.VITE_POSTHOG_API_KEY, {
    api_host: runtimeConfig.VITE_POSTHOG_HOST || "https://app.posthog.com",
    capture_pageview: true,
    capture_pageleave: true,
    mask_all_text: false,
    session_recording: {
      maskAllInputs: false,
      recordCrossOriginIframes: false,
    },
    // Add any additional context or options here
  })
}

// Function to identify user with their information
export const identifyUser = (userId: string, email: string, name: string) => {
  if (posthog) {
    posthog.identify(userId, { email, name })
  }
}

export { posthog }
